import { render, staticRenderFns } from "./twothird.vue?vue&type=template&id=32dfa47a&scoped=true&"
import script from "./twothird.vue?vue&type=script&lang=js&"
export * from "./twothird.vue?vue&type=script&lang=js&"
import style0 from "./twothird.vue?vue&type=style&index=0&id=32dfa47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dfa47a",
  null
  
)

export default component.exports